import React from 'react';
import data from './data/home.json';
import ReactMarkdown from 'react-markdown';

const Home = () => {
    return (
        <>
            <div className='w-full jana-background-large text-200'>
                <div className='flex flex-column m-auto w-full p-3 lg:w-8'>
                <div className='w-9' /*style={{minHeight: '20rem'}}*/>
                    <p className='text-2xl text-400 text-shadow home-intro'>
                        <ReactMarkdown>{data.intro}</ReactMarkdown>
                        {/*<span className='text-300'>South slavic musician</span> based in <span className='text-300'>Vienna, Austria</span>, with a strong foundation
                        in <span className='text-300'>classical violin</span> and a passion for <span className='text-300'>contemporary and experimental music</span>.*/}
                    </p>
                </div>
                <div className='video-container'>
                    <iframe 
                    /*width="560" 
                    height="315"*/
                    className='w-full lg:w-9 h-20rem'
                    src={data.video_link}/*"https://www.youtube.com/embed/BrsY2G2ASOk" */
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen>
                    </iframe>
                </div>
                </div>
            </div>

            <div className='w-full dark-gradient text-200' style={{background: "url('JanaWEB101.PNG'), #010101", backgroundPositionX: '27px', backgroundPositionY: '70px', backgroundSize: '10%', backgroundRepeat: 'no-repeat'}}>
                <div className='flex m-auto w-full p-3 lg:w-9 jana-background-dark'>
                <div className='biography-container w-full lg:w-7 text-300 pt-6 pb-6'>
                    <strong>Biography</strong>
                    <ReactMarkdown>{data.biography}</ReactMarkdown>
                    {/*<p>Jana Pelikan is a south slavic musician based in Vienna, Austria, with a strong foundation in classical violin and a passion for contemporary and experimental music.</p>
                    <p>Born in Zagreb, Croatia, in October 2002, she currently studies Bachelor of Arts classical violin in the class of prof. Anna Kandinskaya at Joseph Haydn Privathochschule in Eisenstadt, Austria.
                    She began her violin education at the age of 7 with prof. Hrvoje Budak in Zagreb. Jana also attended the Ferdo Livadić Music School in Samobor, Croatia.</p>
                    <p>She further improved her skills in the masterclasses of renowned violinists including Ofer Falk, Stephanie Gonley, Ruth Waterman, Orest Shourgut and others.</p>
                    <p>As a soloist, or with chamber music ensembles, Jana won prizes at national and international competitions in Croatia, Italy, Spain and Serbia.</p>
                    <p>As an orchestra musician, as well as a soloist performing recitals and playing street music, she performed throughout Asia and Europe (China, Italy, Spain, Slovenia, Austria, Serbia, Croatia, Bosnia and Herzegovina, Latvia, Germany and Finland).</p>
                    <p>In addition to classical repertoire, Jana explores and composes experimental and improvisational contemporary music. Drawing inspiration from the rich tapestry of South Slavic folk traditions and global folk influences, she is currently in the process of producing her debut album.</p>*/}
                </div>
                </div>
            </div>
        </>
    );
};

export default Home;